<template>
  <div class="container">
    <div class="container" style="flex: 1;">
      <el-form :model="form" style="width: 80%;" ref="refForm" :rules="rules" label-width="180px">
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.selectCustomerInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.customerName') + ':'" prop="customerId">
              <el-select
                v-model="form.customerId"
                clearable
                filterable
                style="width: 100%;"
                size="small"
                @change="changeCustomer">
                <el-option
                  v-for="item in customersList"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.contact') + ':'" prop="contact">
              <el-input
                v-model.trim="form.contact"
                name="contact"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="16">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.contactPhone') + ':'" prop="contactPhone">
              <el-input
                v-model.trim="form.contactPhone"
                name="contactPhone"
                type="tel"
                autocomplete="on"
                clearable
                size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.address') + ':'" prop="contactAddr">
              <el-input
                v-model.trim="form.contactAddr"
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="20">
            <el-form-item :label="$t('common.comment') + ':'">
              <el-input
                v-model="form.comment"
                name="comment"
                type="textarea"
                autocomplete="on"
                clearable
                size="small"
                maxlength="200"
                show-word-limit
                rows="4">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.chooseExpressDelivery')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.expressageType')" prop="expressageType">
              <el-select
                v-model="form.expressageType"
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key) in expressageTypes"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.expressage')" prop="expressage">
              <el-select
                v-model="form.expressage"
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key)  in expressages"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">订单信息</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item label="视芯订单" prop="processingOrderNo">
              <el-input
                v-model.trim="form.processingOrderNo"
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="客户订单" prop="purchaseOrderNo">
              <el-input
                v-model.trim="form.purchaseOrderNo"
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item label="物料编号" prop="customPartNo">
              <el-input
                v-model.trim="form.customPartNo"
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <el-table
              ref="table"
              stripe border
              size="mini"
              :data="form.prodInfos"
              :cell-style="{textAlign: 'center', padding: '3px 0', fontSize: '12px'}"
              :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133'}">
              <el-table-column width="50">
                <template slot-scope="scope">
                  {{scope.$index + 1}}
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('common.productName')"
                width="200">
                <template slot-scope="scope">
                  <el-form-item
                    label-width="0"
                    :prop="'prodInfos.' + scope.$index + '.prodInfo'"
                    :rules="{
                      required: true,
                      trigger: 'blur',
                      validator: (rule, value, callback) => checkProductId(rule, value, callback, scope.$index),
                    }">
                    <el-select
                      v-model="scope.row.prodInfo"
                      clearable
                      filterable
                      style="width: 100%;"
                      size="small">
                      <el-option
                        v-for="item in productsList"
                        :key="item.id"
                        :label="item.productName + ' / ' + item.chipName"
                        :value="item.productName + '/' + item.chipName">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                prop="count"
                :label="$t('common.count')">
                <template slot-scope="scope">
                  <el-form-item
                    label-width="0"
                    :prop="'prodInfos.' + scope.$index + '.count'"
                    :rules="{
                      required: true,
                      trigger: 'blur',
                      validator: (rule, value, callback) => checkCount(rule, value, callback, scope.$index),
                    }">
                    <el-input
                      v-model.trim.number="scope.row.count"
                      name="count"
                      type="tel"
                      autocomplete="on"
                      clearable
                      maxlength="10"
                      size="small"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column width="150" :label="$t('common.operate')">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="deleteProductDetails(scope.$index, scope.row)">
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-form-item label-width="0" style="margin: 10px 0">
          <el-button
            class="orange-button"
            icon="el-icon-plus"
            @click="addClick"
            circle>
          </el-button>
        </el-form-item>>


      </el-form>
      <div class="target-container">

      </div>
    </div>
    <div class="control-container">
      <div>
        <el-button @click="prevStep" size="small" class="prev-button">
          {{$t('common.prevStep')}}
        </el-button>
        <el-button :loading="loading" @click="submitForm" size="small" class="sure-button">
          {{$t('deliveryGoods.sureBuild')}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { tporderPost } from '@/api/tpProdOrder';
import { customersList } from '@/api/customers';
import { productsList } from '@/api/products';
import {
  validateIncomingOrderNo,
  validateLotNo,
  validateCount,
  validateContactPhone,
  validateProductDetails,
} from '@/utils/validate';
import {
  priorityLevels, processTypes, storeStatus, expressages, expressageTypes,
} from '@/utils/defines';
import { isValueEmpty, isPositiveIntegerNum } from '@/utils';


const defaultProductDetail = {
  prodInfo: undefined,
  count: undefined,
};

const defaultForm = {
  processingOrderNo: undefined,
  purchaseOrderNo: undefined,
  customPartNo: undefined,
  customerId: undefined,
  contact: undefined,
  contactPhone: undefined,
  contactAddr: undefined,
  comment: undefined,
  expressageType: expressageTypes.express.val,
  expressage: expressages.SF.val,
  priorityLevel: priorityLevels.low.val,
  lotNos: undefined,
  numbers: undefined,
  binLevelArr: [],
  prodInfos: [{
    ...defaultProductDetail,
  }],
};


export default {
  name: 'check-info',
  props: [
    'selectedOrders',
  ],
  data() {
    const processTypesObj = {};
    let processTypeItem;
    for (const key in processTypes) {
      if (Object.prototype.hasOwnProperty.call(processTypes, key)) {
        processTypeItem = processTypes[key];
        processTypesObj[processTypeItem.val] = processTypeItem.explain;
      }
    }
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.prodOderExplain || storeStatueItem.explain;
      }
    }
    return {
      form: {...defaultForm, prodInfos : [{ ...defaultProductDetail }]},
      rules: {
        customerId: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.customerNameCanNotBeEmpty') }],
        contact: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone }],
        contactAddr: [{ required: true, trigger: 'blur', message: '地址不能为空' }],
        expressageType: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageTypeCanNotBeEmpty') }],
        expressage: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageCanNotBeEmpty') }],
        processingOrderNo: [{ required: true, trigger: 'blur', message: "不能为空" }],
        purchaseOrderNo: [{ required: true, trigger: 'blur', message: "不能为空" }],
        customPartNo: [{ required: true, trigger: 'blur', message: "不能为空" }],
        binLevelArr: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.binLevelArrCanNotBeEmpty') }],
      },
      customersList: [],
      productsList: [],
      productsListObj: {},
      processTypesObj,
      storeStatusObj,
      expressages,
      expressageTypes,
      orders: [],
      loading: false,
    };
  },
  mounted() {
    this.customersListGet(1, 200);
    this.productsListGet(1, 200);
  },
  watch: {
    selectedOrders: {
      handler(newVal) {
        const order = [];
        for (let row of newVal) {
          order.push({...row});
        }
        this.orders = order;
      },
      immediate: true,
    },
  },
  methods: {
    addClick() {
     this.addDetail();
    },
    isEmptyProductDetails() {
      const {
        prodInfos,
      } = this.form;
      if (prodInfos && prodInfos.length === 0) {
        this.$message({
          type: 'error',
          message: this.$t('validate.productDetailsCanNotBeEmpty'),
        });
        return false;
      }
      let prodInfo, count,isDataEmpty, isEmptyProductDetails = true;
      for (let row of prodInfos) {
        prodInfo = row.prodInfo;
        count = row.count;
        isDataEmpty = isValueEmpty(prodInfo) && isValueEmpty(lotNo);
        if (!isDataEmpty) {
          isEmptyProductDetails = false;
           break;
        }
      }
      if (isEmptyProductDetails) {
        this.$message({
          type: 'error',
          message: this.$t('validate.productDetailsCanNotBeEmpty'),
        });
        return false;
      }
      return true;
    },
    addProductDetails() {
      this.form.prodInfos.push({...defaultProductDetail});
    },
    addDetail() {
      this.form.prodInfos.push({...defaultProductDetail});
    },
    deleteProductDetails(index) {
      this.form.prodInfos.splice(index, 1);
    },
    checkCount(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      return validateCount(rule, value, callback);
    },
    checkProductId(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      if (isValueEmpty(value)) {
        callback(new Error(this.$t('validate.productNameCanNotBeEmpty')));
        return false;
      }
      callback();
      return true;
    },
    isAllDataEmpty(index) {
      const {
        prodInfo,
        count,
      } = this.form.prodInfos[index];
      return isValueEmpty(prodInfo) && isValueEmpty(count);
    },
    getRowKeys(row) {
      return row.id;
    },
    prevStep() {
      this.$emit('prevStep');
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          if (!this.isEmptyProductDetails()) {
            return;
          }
          this.sureBuild();
        }
      });
    },
    async sureBuild() {
      const {
        processingOrderNo,
        purchaseOrderNo,
        customPartNo,
        customerId,
        contact,
        contactPhone,
        contactAddr,
        comment,
        expressageType,
        expressage,
        priorityLevel,
        binLevelArr,
        prodInfos,
      } = this.form;
      try {
        const detail = [];
        let prodInfo, count,isDataEmpty;
        prodInfos.map(row => {
          prodInfo = row.prodInfo;
          count = row.count;
          isDataEmpty = isValueEmpty(prodInfo) || isValueEmpty(count);
          if (!isDataEmpty) {
            detail.push(row)
          }
        });
          await tporderPost({
            prodInfos: detail && detail.length > 0 ? detail : undefined,
            priorityLevel,
            customerId,
            contact,
            contactPhone,
            contactAddr,
            comment: comment || undefined,
            expressageType,
            expressage,
            customPartNo, //物料编号,其实都必填，由前台限制
            processingOrderNo, //加工单号,其实都必填，由前台限制
            purchaseOrderNo,
            lotNos:[]
          });
          this.$message({
            type: 'success',
            message: this.$t('deliveryGoods.buildSuccess'),
          });
          this.$emit('nexStep');
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }

    },
    changeCustomer(val) {
      const {
        contact,
        contactPhone,
        contactAddr,
      } = this.form;
      if (val) {
        for (const row of this.customersList) {
          if (row.id === val) {
            this.form.contact = row.contact;
            this.form.contactPhone = row.contactPhone;
            this.form.contactAddr = row.contactAddr;
            this.$refs.refForm.validateField(['customerId', 'contact', 'contactPhone', 'contactAddr']);
            break;
          }
        }
      }
    },
    async productsListGet(page, perpage) {
      try {
        const res = await productsList({ page, perpage });
        const { data } = res;
        this.productsList = data.records;
        this.productsListObj = {};
        for (let row of this.productsList) {
          this.productsListObj[row.id] = row.productName + ' / ' + row.chipName
        }
      } catch (e) {
        // do nothing.
      }
    },
    async customersListGet(page, perpage, customerName) {
      try {
        const res = await customersList({ page, perpage, customerName });
        const { data } = res;
        this.customersList = data.records;
        if (this.customersList && this.customersList.length > 0) {
          const {
            id,
            contact,
            contactPhone,
            contactAddr,
          } = this.customersList[0];
          this.form.customerId = id;
          this.form.contact = contact;
          this.form.contactPhone = contactPhone;
          this.form.contactAddr = contactAddr;
        }
      } catch (e) {
        // do nothing.
      }
    },
    productName(row) {
      const { product } = row;
      if (!product) {
        return '';
      }
      return `${product.productName} / ${product.chipName}`;
    },
    processTypeVal(val) {
      return this.processTypesObj[val];
    },
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 7 || columnIndex === 19) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  .el-form {
    padding: 10px 20px 0;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .control-container {
    background: #F5F5F5;
    padding: 20px;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .target-container {
    margin: 20px 20px 0;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .prev-button {
    background: white;
    color: #EC7900;
    border: #EC7900 solid 1px;
  }
  .sure-button {
    background: #EC7900;
    color: white;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
<template>
  <div class="container">
    <div class="container" style="flex: 1;">
      <el-form :model="form" style="width: 80%;" ref="refForm" :rules="rules" label-width="180px">
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.selectCustomerInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.customerName') + ':'" prop="customerId">
              <el-select
                v-model="form.customerId"
                clearable
                filterable
                style="width: 100%;"
                size="small"
                @change="changeCustomer">
                <el-option
                  v-for="item in customersList"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.contact') + ':'" prop="contact">
              <el-input
                v-model.trim="form.contact"
                name="contact"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="16">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.contactPhone') + ':'" prop="contactPhone">
              <el-input
                v-model.trim="form.contactPhone"
                name="contactPhone"
                type="tel"
                autocomplete="on"
                clearable
                size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.address') + ':'" prop="contactAddr">
              <el-input
                v-model.trim="form.contactAddr"
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="20">
            <el-form-item :label="$t('common.comment') + ':'">
              <el-input
                v-model="form.comment"
                name="comment"
                type="textarea"
                autocomplete="on"
                clearable
                size="small"
                maxlength="200"
                show-word-limit
                rows="4">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.chooseExpressDelivery')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.expressageType')" prop="expressageType">
              <el-select
                v-model="form.expressageType"
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key) in expressageTypes"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.expressage')" prop="expressage">
              <el-select
                v-model="form.expressage"
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key)  in expressages"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">订单信息</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item label="视芯订单" prop="processingOrderNo">
              <el-input
                v-model.trim="form.processingOrderNo"
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="客户订单" prop="purchaseOrderNo">
              <el-input
                v-model.trim="form.purchaseOrderNo"
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item label="物料编号" prop="customPartNo">
              <el-input
                v-model.trim="form.customPartNo"
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <el-table
              ref="table"
              stripe border
              size="mini"
              :data="form.prodInfos"
              :cell-style="{textAlign: 'center', padding: '3px 0', fontSize: '12px'}"
              :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133'}">
              <el-table-column width="50">
                <template slot-scope="scope">
                  {{scope.$index + 1}}
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('common.productName')"
                width="200">
                <template slot-scope="scope">
                  <el-form-item
                    label-width="0"
                    :prop="'prodInfos.' + scope.$index + '.prodInfo'"
                    :rules="{
                      required: true,
                      trigger: 'blur',
                      validator: (rule, value, callback) => checkProductId(rule, value, callback, scope.$index),
                    }">
                    <el-select
                      v-model="scope.row.prodInfo"
                      clearable
                      filterable
                      style="width: 100%;"
                      size="small">
                      <el-option
                        v-for="item in productsList"
                        :key="item.id"
                        :label="item.productName + ' / ' + item.chipName"
                        :value="item.productName + '/' + item.chipName">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                prop="count"
                :label="$t('common.count')">
                <template slot-scope="scope">
                  <el-form-item
                    label-width="0"
                    :prop="'prodInfos.' + scope.$index + '.count'"
                    :rules="{
                      required: true,
                      trigger: 'blur',
                      validator: (rule, value, callback) => checkCount(rule, value, callback, scope.$index),
                    }">
                    <el-input
                      v-model.trim.number="scope.row.count"
                      name="count"
                      type="tel"
                      autocomplete="on"
                      clearable
                      maxlength="10"
                      size="small"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column width="150" :label="$t('common.operate')">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="deleteProductDetails(scope.$index, scope.row)">
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-form-item label-width="0" style="margin: 10px 0">
          <el-button
            class="orange-button"
            icon="el-icon-plus"
            @click="addClick"
            circle>
          </el-button>
        </el-form-item>>


      </el-form>
      <div class="target-container">

      </div>
    </div>
    <div class="control-container">
      <div>
        <el-button @click="prevStep" size="small" class="prev-button">
          {{$t('common.prevStep')}}
        </el-button>
        <el-button :loading="loading" @click="submitForm" size="small" class="sure-button">
          {{$t('deliveryGoods.sureBuild')}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { tporderPost } from '@/api/tpProdOrder';
import { customersList } from '@/api/customers';
import { productsList } from '@/api/products';
import {
  validateIncomingOrderNo,
  validateLotNo,
  validateCount,
  validateContactPhone,
  validateProductDetails,
} from '@/utils/validate';
import {
  priorityLevels, processTypes, storeStatus, expressages, expressageTypes,
} from '@/utils/defines';
import { isValueEmpty, isPositiveIntegerNum } from '@/utils';


const defaultProductDetail = {
  prodInfo: undefined,
  count: undefined,
};

const defaultForm = {
  processingOrderNo: undefined,
  purchaseOrderNo: undefined,
  customPartNo: undefined,
  customerId: undefined,
  contact: undefined,
  contactPhone: undefined,
  contactAddr: undefined,
  comment: undefined,
  expressageType: expressageTypes.express.val,
  expressage: expressages.SF.val,
  priorityLevel: priorityLevels.low.val,
  lotNos: undefined,
  numbers: undefined,
  binLevelArr: [],
  prodInfos: [{
    ...defaultProductDetail,
  }],
};


export default {
  name: 'check-info',
  props: [
    'selectedOrders',
  ],
  data() {
    const processTypesObj = {};
    let processTypeItem;
    for (const key in processTypes) {
      if (Object.prototype.hasOwnProperty.call(processTypes, key)) {
        processTypeItem = processTypes[key];
        processTypesObj[processTypeItem.val] = processTypeItem.explain;
      }
    }
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.prodOderExplain || storeStatueItem.explain;
      }
    }
    return {
      form: {...defaultForm, prodInfos : [{ ...defaultProductDetail }]},
      rules: {
        customerId: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.customerNameCanNotBeEmpty') }],
        contact: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone }],
        contactAddr: [{ required: true, trigger: 'blur', message: '地址不能为空' }],
        expressageType: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageTypeCanNotBeEmpty') }],
        expressage: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageCanNotBeEmpty') }],
        processingOrderNo: [{ required: true, trigger: 'blur', message: "不能为空" }],
        purchaseOrderNo: [{ required: true, trigger: 'blur', message: "不能为空" }],
        customPartNo: [{ required: true, trigger: 'blur', message: "不能为空" }],
        binLevelArr: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.binLevelArrCanNotBeEmpty') }],
      },
      customersList: [],
      productsList: [],
      productsListObj: {},
      processTypesObj,
      storeStatusObj,
      expressages,
      expressageTypes,
      orders: [],
      loading: false,
    };
  },
  mounted() {
    this.customersListGet(1, 200);
    this.productsListGet(1, 200);
  },
  watch: {
    selectedOrders: {
      handler(newVal) {
        const order = [];
        for (let row of newVal) {
          order.push({...row});
        }
        this.orders = order;
      },
      immediate: true,
    },
  },
  methods: {
    addClick() {
     this.addDetail();
    },
    isEmptyProductDetails() {
      const {
        prodInfos,
      } = this.form;
      if (prodInfos && prodInfos.length === 0) {
        this.$message({
          type: 'error',
          message: this.$t('validate.productDetailsCanNotBeEmpty'),
        });
        return false;
      }
      let prodInfo, count,isDataEmpty, isEmptyProductDetails = true;
      for (let row of prodInfos) {
        prodInfo = row.prodInfo;
        count = row.count;
        isDataEmpty = isValueEmpty(prodInfo) && isValueEmpty(count);
        if (!isDataEmpty) {
          isEmptyProductDetails = false;
           break;
        }
      }
      if (isEmptyProductDetails) {
        this.$message({
          type: 'error',
          message: this.$t('validate.productDetailsCanNotBeEmpty'),
        });
        return false;
      }
      return true;
    },
    addProductDetails() {
      this.form.prodInfos.push({...defaultProductDetail});
    },
    addDetail() {
      this.form.prodInfos.push({...defaultProductDetail});
    },
    deleteProductDetails(index) {
      this.form.prodInfos.splice(index, 1);
    },
    checkCount(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      return validateCount(rule, value, callback);
    },
    checkProductId(rule, value, callback, index) {
      if (this.isAllDataEmpty(index)) {
        callback();
        return true;
      }
      if (isValueEmpty(value)) {
        callback(new Error(this.$t('validate.productNameCanNotBeEmpty')));
        return false;
      }
      callback();
      return true;
    },
    isAllDataEmpty(index) {
      const {
        prodInfo,
        count,
      } = this.form.prodInfos[index];
      return isValueEmpty(prodInfo) && isValueEmpty(count);
    },
    getRowKeys(row) {
      return row.id;
    },
    prevStep() {
      this.$emit('prevStep');
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          if (!this.isEmptyProductDetails()) {
            return;
          }
          this.sureBuild();
        }
      });
    },
    async sureBuild() {
      const {
        processingOrderNo,
        purchaseOrderNo,
        customPartNo,
        customerId,
        contact,
        contactPhone,
        contactAddr,
        comment,
        expressageType,
        expressage,
        priorityLevel,
        binLevelArr,
        prodInfos,
      } = this.form;
      try {
        const detail = [];
        let prodInfo, count,isDataEmpty;
        prodInfos.map(row => {
          prodInfo = row.prodInfo;
          count = row.count;
          isDataEmpty = isValueEmpty(prodInfo) || isValueEmpty(count);
          if (!isDataEmpty) {
            detail.push(row)
          }
        });
          await tporderPost({
            prodInfos: detail && detail.length > 0 ? detail : undefined,
            priorityLevel,
            customerId,
            contact,
            contactPhone,
            contactAddr,
            comment: comment || undefined,
            expressageType,
            expressage,
            customPartNo, //物料编号,其实都必填，由前台限制
            processingOrderNo, //加工单号,其实都必填，由前台限制
            purchaseOrderNo,
            lotNos:[]
          });
          this.$message({
            type: 'success',
            message: this.$t('deliveryGoods.buildSuccess'),
          });
          this.$emit('nexStep');
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }

    },
    changeCustomer(val) {
      const {
        contact,
        contactPhone,
        contactAddr,
      } = this.form;
      if (val) {
        for (const row of this.customersList) {
          if (row.id === val) {
            this.form.contact = row.contact;
            this.form.contactPhone = row.contactPhone;
            this.form.contactAddr = row.contactAddr;
            this.$refs.refForm.validateField(['customerId', 'contact', 'contactPhone', 'contactAddr']);
            break;
          }
        }
      }
    },
    async productsListGet(page, perpage) {
      try {
        const res = await productsList({ page, perpage });
        const { data } = res;
        this.productsList = data.records;
        this.productsListObj = {};
        for (let row of this.productsList) {
          this.productsListObj[row.id] = row.productName + ' / ' + row.chipName
        }
      } catch (e) {
        // do nothing.
      }
    },
    async customersListGet(page, perpage, customerName) {
      try {
        const res = await customersList({ page, perpage, customerName });
        const { data } = res;
        this.customersList = data.records;
        if (this.customersList && this.customersList.length > 0) {
          const {
            id,
            contact,
            contactPhone,
            contactAddr,
          } = this.customersList[0];
          this.form.customerId = id;
          this.form.contact = contact;
          this.form.contactPhone = contactPhone;
          this.form.contactAddr = contactAddr;
        }
      } catch (e) {
        // do nothing.
      }
    },
    productName(row) {
      const { product } = row;
      if (!product) {
        return '';
      }
      return `${product.productName} / ${product.chipName}`;
    },
    processTypeVal(val) {
      return this.processTypesObj[val];
    },
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 7 || columnIndex === 19) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  .el-form {
    padding: 10px 20px 0;
  }
  .el-form-item {
    margin-bottom: 10px;
    padding: 6px;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .control-container {
    background: #F5F5F5;
    padding: 20px;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .target-container {
    margin: 20px 20px 0;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .prev-button {
    background: white;
    color: #EC7900;
    border: #EC7900 solid 1px;
  }
  .sure-button {
    background: #EC7900;
    color: white;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
